const INDEX = '/'
const ADMIN_PATH = '/admin'
const API_PATH = '/API'
const ORDER_PATH = '/orders'
const ASSIGNMENT_PATH = '/assignment'
const EMAIL_VERIFICATION_PATH = '/email-verification'
const EMAIL_VERIFIED_PATH = '/email-verified'
const FORGOT_PASSWORD_PATH = '/forgot-password'
const GALLERY_PATH = '/gallery'
const TEST_GALLERY_PATH = '/gallery-test'
const PROPERTY_PATH = '/property'
const PROPERTIES_PATH = '/properties'
const LOGIN_PATH = '/login'
const PAYMENT_STATUS_PATH = '/payment-status'
const PROFILE_PATH = '/profile'
const PROFILE_TAB_PATH = '/profile/:tab'
const PURCHASE_FLOW_PATH = '/purchase-flow'
const PURCHASE_FLOW_REVAMP_PATH = '/purchase-flow-revamp'
const EMBED_PURCHASE_FLOW_PATH = '/embed/purchase-flow'
const EMBED_STATUS_CARD_PATH = '/embed/status-card'
const EMBED_ONOFFICE_PATH = '/embed/onoffice'
const SIGNUP_PATH = '/signup'
const SIGNUP_PORTAL_PATH = '/signup-portal'
const SUBSCRIPTION_PATH = '/subscription'
const SUBSCRIPTION_STATUS_PATH = '/subscription-status'
const TERMS_AND_PRIVACY_PATH = '/terms-and-privacy'
const WORKSPACE_CREATION_PATH = '/workspace-creation'
const WORKSPACE_SETTINGS_PATH = '/workspace-settings'
const WORKSPACES_PROFILE_PATH = '/workspaces-profile'

/** Contains all available router paths */
export const Path = {
  INDEX,
  CT_UPLOAD: `${INDEX}:id/upload`,
  TERMS_AND_PRIVACY: TERMS_AND_PRIVACY_PATH,
  PROFILE: PROFILE_PATH,
  PROFILE_TAB: PROFILE_TAB_PATH,
  PROFILE_SETTINGS: `${PROFILE_PATH}/settings`,
  LOGIN: LOGIN_PATH,
  SIGNUP: SIGNUP_PATH,
  SIGNUP_PORTAL: SIGNUP_PORTAL_PATH,
  ORDERS: ORDER_PATH,
  GALLERY: `${GALLERY_PATH}/:id`,
  GALLERY_INFO: `${GALLERY_PATH}/:id/:tab`,
  GALLERY_NO_SLUG: `${GALLERY_PATH}`,
  GALLERY_TEST: `${TEST_GALLERY_PATH}/:id`,
  GALLERY_NO_SLUG_TEST: `${TEST_GALLERY_PATH}`,
  GALLERY_STAGING: `${GALLERY_PATH}/:id/staging`,
  GALLERY_VISUALS_EDIT: `${GALLERY_PATH}/:id/edit`,
  GALLERY_VISUAL_PHOTO_STUDIO: `${GALLERY_PATH}/:id/photo-studio`,
  GALLERY_VISUALS_MARKETING: `${GALLERY_PATH}/:id/marketing`,
  PROPERTIES_DASHBOARD: PROPERTIES_PATH,
  NEW_PROPERTIES: `${PROPERTIES_PATH}/create-property`,
  PROPERTY_NO_SLUG: `${PROPERTY_PATH}`,
  PROPERTY_ID: `${PROPERTY_PATH}/:id`,
  PROPERTY_TAB: `${PROPERTY_PATH}/:id/:tab`,
  PROPERTY_TAB_ASSIGNMENT: `${PROPERTY_PATH}/:id/:tab/:assignmentId`,
  PROPERTY_DOCUMENTS: `${PROPERTY_PATH}/:id/documents`,
  PROPERTY_DOCUMENTS_ASSIGNMENT: `${PROPERTY_PATH}/:id/documents/:assignmentId`,
  PROPERTY_VISUALS_GALLERY: `${PROPERTY_PATH}/:id/gallery`,
  PROPERTY_VISUALS_GALLERY_ASSIGNMENT: `${PROPERTY_PATH}/:id/gallery/:assignmentId`,
  PROPERTY_ASSIGNMENT_EXPORTING_OPTIONS: `${PROPERTY_PATH}/:id${GALLERY_PATH}/:assignmentId/edit`,
  PROPERTY_ASSIGNMENT_PHOTO_STUDIO: `${PROPERTY_PATH}/:id${GALLERY_PATH}/:assignmentId/photo-studio`,
  PROPERTY_ASSIGNMENT_STAGING: `${PROPERTY_PATH}/:id${GALLERY_PATH}/:assignmentId/staging`,
  PROPERTY_INFO: `${PROPERTY_PATH}/:id/information`,
  PROPERTY_ORDERS: `${PROPERTY_PATH}/:id/orders`,
  PROPERTY_AI_TEXT_GENERATOR: `${PROPERTY_PATH}/:id/ai_text_generator`,
  PROPERTY_MARKETING_CAMPAIGN: `${PROPERTY_PATH}/:id/marketing_campaign`,
  EMAIL_VERIFIED: EMAIL_VERIFIED_PATH,
  EMAIL_VERIFICATION: EMAIL_VERIFICATION_PATH,
  FORGOT_PASSWORD: FORGOT_PASSWORD_PATH,
  PAYMENT_STATUS: PAYMENT_STATUS_PATH,
  SUBSCRIPTION_STATUS: SUBSCRIPTION_STATUS_PATH,
  ADMIN_CLIENT_ONBOARDING: `${ADMIN_PATH}/client-onboarding`,
  ADMIN_CREATIVE_ONBOARDING: `${ADMIN_PATH}/creative-onboarding`,
  AVAILABLE_ASSIGNMENT: `${ASSIGNMENT_PATH}/:id`,
  CREATIVE_GUIDELINES_PREVIEW: '/guidelines',
  CREATIVE_GUIDELINES_FOR_KIND: '/guidelines/:productKind',
  LIGHTROOM_PLUGIN_GUIDE: '/lightroom-plugin',
  SUBSCRIPTION: SUBSCRIPTION_PATH,
  SUBSCRIPTION_CREATION: `${SUBSCRIPTION_PATH}/plan-creation`,
  SUBSCRIPTION_MEMBERS: `${SUBSCRIPTION_PATH}/add-members`,
  SUBSCRIPTION_VALIDATION: `${SUBSCRIPTION_PATH}/validation`,
  API: API_PATH,
  WORKSPACE_CREATION: WORKSPACE_CREATION_PATH,
  WORKSPACE_SETTINGS: WORKSPACE_SETTINGS_PATH,
  WORKSPACE_SETTINGS_TAB: `${WORKSPACE_SETTINGS_PATH}/:tab`,
  WORKSPACE_SETTINGS_WORKSPACE: `${WORKSPACE_SETTINGS_PATH}/information`,
  WORKSPACE_SETTINGS_MEMBERS: `${WORKSPACE_SETTINGS_PATH}/members`,
  WORKSPACE_SETTINGS_INTEGRATIONS: `${WORKSPACE_SETTINGS_PATH}/integrations`,
  WORKSPACE_SETTINGS_PLAN: `${WORKSPACE_SETTINGS_PATH}/plan`,
  WORKSPACES_PROFILE: `${WORKSPACES_PROFILE_PATH}/:id`,
  PURCHASE_FLOW: PURCHASE_FLOW_PATH,
  PURCHASE_FLOW_REVAMP: PURCHASE_FLOW_REVAMP_PATH,
  EMBED_PURCHASE_FLOW: EMBED_PURCHASE_FLOW_PATH,
  /** PF v2 owns its own steps under the embed path. Patterns, not destinations:
   *  they exist so the segment-counting matchers (NO_HEADER_PATHS) cover a step
   *  as well as the bare entry — without them the main app's header renders
   *  inside the CRM iframe from the first step onwards. */
  EMBED_PURCHASE_FLOW_STEP: `${EMBED_PURCHASE_FLOW_PATH}/:step`,
  EMBED_PURCHASE_FLOW_SESSION_STEP: `${EMBED_PURCHASE_FLOW_PATH}/session/:sessionId/:step`,
  EMBED_PURCHASE_FLOW_SESSION_CONFIGURATION: `${EMBED_PURCHASE_FLOW_PATH}/session/:sessionId/:step/:cartItemId/:flowId`,
  EMBED_PURCHASE_FLOW_CONFIGURATION: `${EMBED_PURCHASE_FLOW_PATH}/:step/:cartItemId/:flowId`,
  EMBED_STATUS_CARD: EMBED_STATUS_CARD_PATH,
  /** Where crm-integrations redirects the onOffice iframe with its one-time code (or an error code). */
  EMBED_ONOFFICE: EMBED_ONOFFICE_PATH,
  PURCHASE_FLOW_REVAMP_SELECT_USER: `${PURCHASE_FLOW_REVAMP_PATH}/select-user`,
  PURCHASE_FLOW_REVAMP_SELECT_PROPERTY: `${PURCHASE_FLOW_REVAMP_PATH}/select-property`,
  PURCHASE_FLOW_REVAMP_CATALOGUE: `${PURCHASE_FLOW_REVAMP_PATH}/catalogue`,
  /** Configuration step — one tab per (cartItem, flow) tuple. `:cartItemId`
   *  is the client-side uuid from `cartSlice`. `:flowId` is the
   *  `ConfigurationFlowId` for this tab (a single product can require multiple
   *  flows, e.g. authorities documents that stack `power_of_attorney` +
   *  `property_info`). Route registered in Module 9. */
  PURCHASE_FLOW_REVAMP_CONFIGURATION: `${PURCHASE_FLOW_REVAMP_PATH}/configuration/:cartItemId/:flowId`,
  /** Backwards-compatible legacy shape — `/configuration/:cartItemId` (no
   *  `:flowId`). Redirects to the cart item's first flow. Kept so cart-side
   *  navigation that pre-dates the multi-flow route shape still resolves
   *  cleanly during the transition. */
  PURCHASE_FLOW_REVAMP_CONFIGURATION_LEGACY: `${PURCHASE_FLOW_REVAMP_PATH}/configuration/:cartItemId`,
  PURCHASE_FLOW_REVAMP_INSTRUCTIONS: `${PURCHASE_FLOW_REVAMP_PATH}/instructions`,
  PURCHASE_FLOW_REVAMP_BILLING: `${PURCHASE_FLOW_REVAMP_PATH}/billing`,
  PURCHASE_FLOW_REVAMP_SUMMARY: `${PURCHASE_FLOW_REVAMP_PATH}/summary`,
  /** Any step under a session segment, which the flow URL carries once a session exists. */
  PURCHASE_FLOW_REVAMP_SESSION_STEP: `${PURCHASE_FLOW_REVAMP_PATH}/session/:sessionId/:step`,
  PURCHASE_FLOW_REVAMP_SESSION_CONFIGURATION: `${PURCHASE_FLOW_REVAMP_PATH}/session/:sessionId/configuration/:cartItemId/:flowId`,
  PURCHASE_FLOW_REVAMP_SESSION_CONFIGURATION_LEGACY: `${PURCHASE_FLOW_REVAMP_PATH}/session/:sessionId/configuration/:cartItemId`,
} as const

export type PathType = typeof Path
export type PathTypeValue = PathType[keyof PathType]

/** Array of paths that use new design language */
export const NEW_DESIGN_PATHS: Array<PathTypeValue> = [Path.GALLERY_VISUALS_MARKETING]

/** Array of paths that don't use header */
export const NO_HEADER_PATHS: Array<PathTypeValue> = [Path.CT_UPLOAD, Path.GALLERY_VISUALS_EDIT, Path.GALLERY_VISUAL_PHOTO_STUDIO, Path.GALLERY_VISUALS_MARKETING, Path.GALLERY_STAGING, Path.SIGNUP_PORTAL, Path.FORGOT_PASSWORD, Path.PURCHASE_FLOW, Path.PURCHASE_FLOW_REVAMP, Path.PURCHASE_FLOW_REVAMP_SELECT_USER, Path.PURCHASE_FLOW_REVAMP_SELECT_PROPERTY, Path.PURCHASE_FLOW_REVAMP_CATALOGUE, Path.PURCHASE_FLOW_REVAMP_CONFIGURATION, Path.PURCHASE_FLOW_REVAMP_CONFIGURATION_LEGACY, Path.PURCHASE_FLOW_REVAMP_INSTRUCTIONS, Path.PURCHASE_FLOW_REVAMP_BILLING, Path.PURCHASE_FLOW_REVAMP_SUMMARY, Path.PURCHASE_FLOW_REVAMP_SESSION_STEP, Path.PURCHASE_FLOW_REVAMP_SESSION_CONFIGURATION, Path.PURCHASE_FLOW_REVAMP_SESSION_CONFIGURATION_LEGACY, Path.EMBED_PURCHASE_FLOW, Path.EMBED_PURCHASE_FLOW_STEP, Path.EMBED_PURCHASE_FLOW_CONFIGURATION, Path.EMBED_PURCHASE_FLOW_SESSION_STEP, Path.EMBED_PURCHASE_FLOW_SESSION_CONFIGURATION, Path.EMBED_STATUS_CARD, Path.EMBED_ONOFFICE, Path.PROPERTY_ASSIGNMENT_EXPORTING_OPTIONS, Path.PROPERTY_ASSIGNMENT_PHOTO_STUDIO, Path.PROPERTY_ASSIGNMENT_STAGING, Path.NEW_PROPERTIES, Path.WORKSPACE_CREATION]

/** URL prefix shared by every Propstack partner-iframe embed surface (purchase-flow, status-card) */
export const EMBED_PATH_PREFIX = '/embed/'

/**
 * True when `pathname` is a Propstack embed surface. This is the single gate used to suppress
 * third-party support/tracking widgets (Hotjar, Intercom, Userpilot, Satismeter, Salesforce
 * Embedded Messaging, ChatWidget) inside the partner iframe — mirroring how the header is
 * suppressed, but embed-specific so the normal `/purchase-flow` route is left untouched.
 *
 * Defaults to the live `window.location.pathname` so it can also gate bootstrap-time inits that
 * run before the router mounts. A trailing slash (Propstack-controlled URLs sometimes carry one)
 * still matches. Matched case-insensitively because the router resolves routes case-insensitively —
 * a case-variant URL must not fail open and re-enable the suppressed trackers. See ISSUE-2310.
 */
export const isEmbedRoute = (pathname: string = window.location.pathname): boolean =>
  pathname.toLowerCase().startsWith(EMBED_PATH_PREFIX)

/**
 * True when `pathname` is the embedded purchase flow **or any step inside it**.
 *
 * Separate from [isEmbedRoute] because that one also matches the status card, and separate from an
 * exact match on [Path.EMBED_PURCHASE_FLOW] because PF v2 gave the embed sub-routes
 * (`/embed/purchase-flow/catalogue`, …) where legacy had a single URL driven by internal step state.
 * An exact match therefore flips to false the moment the client leaves the first screen, which is
 * how the Propstack-forced `?lang` came to be overridden by the broker's profile language mid-order.
 *
 * Trailing slash and case are tolerated for the same reasons [isEmbedRoute] tolerates them.
 */
export const isEmbedPurchaseFlowPath = (pathname: string = window.location.pathname): boolean => {
  const normalized = pathname.toLowerCase().replace(/\/+$/, '')
  return normalized === EMBED_PURCHASE_FLOW_PATH || normalized.startsWith(`${EMBED_PURCHASE_FLOW_PATH}/`)
}
